import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Link as RouterLink } from 'react-router-dom';
import { APPLICATION_RELEASE_STATE } from './releaseState';
import { ROUTES } from './routes';

export default function EarlyAccessPage() {
  useEffect(() => {
    document.title = 'JourneyBot Early Access';
  }, []);

  return (
    <Box sx={{ bgcolor: 'background.default', color: 'text.primary', textAlign: 'left', py: { xs: 4, md: 7 } }}>
      <Container maxWidth="md">
        <Stack spacing={3}>
          <Box>
            <Typography variant="h3" component="h1" sx={{ fontWeight: 900, mb: 1 }}>
              JourneyBot Early Access
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Current release state: {APPLICATION_RELEASE_STATE.replace('_', ' ')}
            </Typography>
          </Box>

          <Box component="section">
            <Typography variant="h5" component="h2" sx={{ fontWeight: 800, mb: 1 }}>
              What Early Access Means
            </Typography>
            <Typography variant="body1" paragraph>
              JourneyBot is still under active development and is not yet considered production-grade.
              Features may change, and you may encounter errors, interruptions or data loss.
            </Typography>
            <Typography variant="body1">
              Keep independent copies of important information and verify important outputs before
              using them for decisions or documents.
            </Typography>
          </Box>

          <Box component="section">
            <Typography variant="h5" component="h2" sx={{ fontWeight: 800, mb: 1 }}>
              Known Limitations
            </Typography>
            <Box component="ul" sx={{ mt: 1, pl: 3 }}>
              <Typography component="li" variant="body1">Some workflows may be incomplete or change without notice.</Typography>
              <Typography component="li" variant="body1">Availability is not guaranteed.</Typography>
              <Typography component="li" variant="body1">AI-generated or imported content may be incomplete or inaccurate.</Typography>
            </Box>
          </Box>

          <Box component="section">
            <Typography variant="h5" component="h2" sx={{ fontWeight: 800, mb: 1 }}>
              Backup Recommendation
            </Typography>
            <Typography variant="body1" paragraph>
              Export your journey data regularly and keep a copy outside JourneyBot.
            </Typography>
            <Button
              component={RouterLink}
              to={ROUTES.mainView}
              variant="contained"
              color="primary"
              startIcon={<FileDownloadOutlinedIcon />}
              data-testid="early-access-export-link"
            >
              Go to journey export
            </Button>
          </Box>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <Link component={RouterLink} to={ROUTES.terms}>Terms of Use</Link>
            <Link component={RouterLink} to={ROUTES.privacy}>Privacy Policy</Link>
            <Link href="mailto:saywhat@firsthomebuyers.app">Send feedback</Link>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
